<template>
  <div class="layout-box">
    <LayoutHeader headtitle="行业标准" :kls="true"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="experts-title">
        <h2>化纤标准</h2>
<!--        <div class="bread-crumb-nav">当前位置：<a @click="$router.go(-1)">首页</a> > 行业标准</div>-->
        <ul class="cut-title">
          <li :class='num==0?"on":""' @click="cutlist(0)">国家标准</li>
          <li :class='num==1?"on":""' @click="cutlist(1)">行业标准</li>
          <li :class='num==2?"on":""' @click="cutlist(2)">团体标准</li>
        </ul>
      </div>
      <ul :style='num==0?"display: block;":"display: none;"' class="experts-list clear">
        <li>
          <a href="https://forum.ccf.com.cn/fiber/pdf/fzpm.pdf" target="_blank">₪ 纺织纤维编码标准</a>
          <span>2021-04-20</span>
        </li>
        <li>
          <a href="https://forum.ccf.com.cn/fiber/pdf/bmtm.pdf" target="_blank">₪ 聚酯切片阻燃性能试验方法等8项协会标准复审结论通知</a>
          <span>2017-12-21</span>
        </li>
        <li>
          <a>₪ 现行46项国标</a>
          <span>2020-05-22</span>
        </li>
        <li>
          <a>₪ 《纺织品化学纤维第2部分：产品术语》国家标准发布</a>
          <span>2017-08-24</span>
        </li>
        <li>
          <a>₪ ISO标准</a>
          <span>2015-12-14</span>
        </li>
      </ul>
      <ul :style='num==1?"display: block;":"display: none;"' class="experts-list clear">
        <li>
          <a href="/Indunowledgedetails?id=9">▶▹ 【标准】4项化纤推荐性国标、17项化纤行业标准发布</a>
          <span>2022-05-06</span>
        </li>
        <li>
          <a>▶▹ 现行201项行标</a>
          <span>2014-04-01</span>
        </li>
      </ul>
      <ul :style='num==2?"display: block;":"display: none;"' class="experts-list clear">
        <li>
          <a>ↇ 现行60项团体标准</a>
          <span>2020-06-09</span>
        </li>
        <li>
          <a>ↇ 聚酯切片阻燃性能试验方法等8项协会标准复审结论通知</a>
          <span>2017-12-21</span>
        </li>
        <li>
          <a>ↇ 中化协〔2017〕5号 关于印发化纤协会标准制修订计划的通知</a>
          <span>2017-01-24</span>
        </li>
        <li>
          <a>ↇ 《循环再利用化学纤维（涤纶）行业绿色采购规范》化纤协会团体标准自2016年...</a>
          <span>2016-08-23</span>
        </li>
        <li>
          <a>ↇ 《纤维级循环再利用聚酯（PET）泡料》化纤协会团体标准自2016年9月1日在行业...</a>
          <span>2016-08-23</span>
        </li>
        <li>
          <a>ↇ 关于印发化纤协会标准制修订计划的通知</a>
          <span>2016-03-24</span>
        </li>
        <li>
          <a>ↇ 《循环再利用聚酯（PET）鉴别方法》等2项化纤协会标准自2016年3月1日在行业...</a>
          <span>2016-01-20</span>
        </li>
        <li>
          <a>ↇ 《黑色氨纶长丝》等3项化纤协会标准自2016年2月1日在行业内实施</a>
          <span>2016-01-20</span>
        </li>
        <li>
          <a>ↇ 国标委印发《2015年全国标准化工作要点》 共5部分36条</a>
          <span>2015-04-27</span>
        </li>
        <li>
          <a>ↇ 两项化纤协会产品标准将于4月1日实施</a>
          <span>2015-03-04</span>
        </li>
        <li>
          <a>ↇ 关于中国化学纤维工业协会标准发布的通知</a>
          <span>2014-07-25</span>
        </li>
        <li>
          <a>ↇ 关于第一批中国化学纤维工业协会标准发布的通知</a>
          <span>2012-01-04</span>
        </li>
        <li>
          <a>ↇ 2011年化纤标准化工作会议暨化纤协会标准化工作委员会年会现场报道</a>
          <span>2011-12-20</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";
export default {
  name: 'IndustryStandard',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      num:0
    }
  },
  methods: {
    cutlist(n){
      this.num=n;
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
}

.secondary-content{
  width: 1100px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
  display: flex;
  justify-content: space-between;
}

.experts-title h2{
  font-family: "fzskjt";
  line-height: 59px;
  color:#fff;
  font-style: oblique;
  padding-left: 20px;
}

.bread-crumb-nav{
  font-size: 16px;
  color: #fff;
  font-family: 微软雅黑;
  line-height: 59px;
  padding-left: 20px;
}

.bread-crumb-nav a{
  cursor: pointer;
  color: #fff;
  text-decoration: none;
}
.bread-crumb-nav a:hover{
  text-decoration: underline;
  font-weight: bold;
}

.cut-title{
  width: 370px;
  display: flex;
  justify-content: space-around;
  align-self: flex-end;
}

.cut-title li{
  height: 36px;
  color: #fff;
  font-size: 16px;
  line-height: 36px;
  padding: 0 18px;
  font-family: 微软雅黑;
  background-image: linear-gradient(rgba(33,84,235,1),rgba(45,91,237,.54));
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  cursor: pointer;
}

.cut-title li:hover{
  text-shadow: 0 4px 2px rgba(0, 0, 0, 0.7);
  background-image: linear-gradient(rgba(45,91,237,.54),rgba(33,84,235,1));
}

.cut-title li.on{
  background-image: linear-gradient(rgba(243,116,118,1),rgba(243,116,118,.54));
}

.experts-list{
  overflow: auto;
  height: calc(100% - 80px);
  padding: 18px 0 18px 18px;
}

.experts-list::-webkit-scrollbar{
  display: none;
}

.experts-list li{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100%-40px);
  padding: 15px 20px;
  margin: 5px 0;
}

.experts-list li a{
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  text-decoration: none;
}

.experts-list li:hover{
  text-decoration: underline;
  background: #0B42AF;
}

.experts-list li span{
  color: #E3E9F6;
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/views/secondary/secondary-industrystandard-list.vue